import { render, staticRenderFns } from "./Gerador.vue?vue&type=template&id=73852b6f"
import script from "./Gerador.vue?vue&type=script&lang=js"
export * from "./Gerador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports